import React, { useEffect, useState, useRef } from "react";
import "../../Styles/CommonStyles.scss";
import {
  Button,
  Label,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import DSBAlogo from "../../Images/DSBAlogo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import eventApiSlice, { IEvent } from "../../store/eventApiSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import dayjs, { Dayjs } from "dayjs";
import ReportServices from "../../services/ReportServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { createTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Modal, Form } from 'react-bootstrap';
interface Iprops {
  //callBackClose: () => void;
}


interface LogEntry {
    run_date: string; // ISO date string
    status: string; // e.g., "In Progress", "Completed", "Failed"
    description: string; // Description of the log entry
    start_time: string; // ISO date string or empty string
    end_time: string; // ISO date string or empty string
}

interface Instance {
    Instance_Id: string; // Unique identifier for the instance
    run_date: string; // ISO date string
    logs: LogEntry[]; // Array of log entries associated with the instance
}

interface JobDataResponse {
    data: {
        Id: number; // Job ID
        Name: string; // Job Name
        Instances: Instance[]; // Array of instances related to the job
    }[];
    status: boolean; // Indicates the success of the response
    hasErrors: boolean; // Indicates if there were errors in the response
    errors: string[]; // Array of error messages, if any
}




const JobScreen: React.FC<Iprops> = (props) => {

    const ArrowIcon: React.FC<{ isExpanded: boolean }> = ({ isExpanded }) => {
        return (
            <svg
                width="24"  // Increased size
                height="24" // Increased size
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}
                className="ms-2"
            >
                <path d="M4 6L8 10L12 6H4Z" fill="currentColor" />
            </svg>
        );
    };
  
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const eventInfo: IEvent = useSelector(
    (state: RootState) => state.eventapislice.event
  );


  const [jobData, setJobData] = useState<JobDataResponse>({} as JobDataResponse);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [expandedRow, setExpandedRow] = useState<number | null>(null); // State to track expanded rows

  const handleShow = () => setShowModal(true);
const handleClose = () => setShowModal(false);



const [showModal, setShowModal] = useState(false);
const [selectedFiscalYear, setSelectedFiscalYear] = useState<string | null>(null);
const [emailInvoice, setEmailInvoice] = useState<boolean>(false);

  const color1 = "#2d6289"; // Use the same color as in FMPersonalInfo
  
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

    const handleRun = (jobId: number) => {
        // Logic to handle the run action for the job
        console.log(`Running job with ID: ${jobId}`);
        if(jobId === 1) {
              ReportServices.runVideoJob(jobId).then((response) => {
                if (response.data.hasErrors) {
                    setShowAlertModal(true);
                    setAlertTitle("Database Error");
                    setAlertBody(response.data.errors[0].sqlMessage);
                    return;
                }
                setShowAlertModal(true);
                setAlertTitle("Success");
                setAlertBody("Job running successfully");
                console.log("runJob:", response.data);
                fetchData();
            });    
        }else if(jobId === 2) {
          setShowModal(true);
        }
        
    };

    const handleSubmit = () => {
      console.log(`Selected Fiscal Year: ${selectedFiscalYear}`);
      handleClose();
      let fiscalYear = "";
      const currentMonth = new Date().getMonth() + 1; 

      if(selectedFiscalYear === "Current Fiscal Year"){
        if(currentMonth > 2 && currentMonth < 7){
          fiscalYear = `${new Date().getFullYear() - 1}-${new Date().getFullYear()}`;
        }else{
          fiscalYear = `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`;
        }
      }else{
        if(currentMonth > 2 && currentMonth < 7){
          fiscalYear = `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`;
        }else{
          fiscalYear = `${new Date().getFullYear() + 1}-${new Date().getFullYear() + 2}`;
        }
      }

      ReportServices.runMembershipJob(`{"FiscalYear":"${fiscalYear}","EmailInvoice":${emailInvoice}}`).then((response) => {
        if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
        }
        setShowAlertModal(true);
        setAlertTitle("Success");
        setAlertBody("Job running successfully");
        console.log("runJob:", response.data);
        fetchData();
    });
  };

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await ReportServices.fetchJobData();

        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("fetchJobData:", response.data.data);
          const data = response.data.data;
          setJobData(response.data);

        } else {
          setError("Error fetching data: " + response.data.errors.join(","));
        }
      } catch (err) {
        setError("API call failed: " + err);
      } finally {
        setLoading(false);
      }
    };

    const sendReminderEmail = () => {
      const confirmRun = window.confirm("Are you sure you want to send reminder email?");
      if (confirmRun) {
        console.log("sendReminderEmail");
        setLoading(true);
        ReportServices.sendReminderEmail().then((response) => {
          if (response.data.hasErrors) {
              setShowAlertModal(true);
              setAlertTitle("Database Error");
              setAlertBody(response.data.errors[0].sqlMessage);
              return;
          }
          setShowAlertModal(true);
          setAlertTitle("Success");
          setAlertBody("Job running successfully");
          console.log("runJob:", response.data);
          fetchData();
      });
    };
      
    };


    const handleRowClick = (index: number) => {
        setExpandedRow(expandedRow === index ? null : index); // Toggle row expansion
    };
    useEffect(() => {
      fetchData();
    }, []);

  const PrintLabelRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ content: () => PrintLabelRef.current });

  return (
    <>
      <div
        className="horizontal-wrapper-spacebetween"
        style={{ alignItems: "center" }}
      >
        <h1 className="page-heading d-block" style={{ height: "auto" }}>
          Scheduled Jobs
        </h1>

        <div className="tableContainer" ref={PrintLabelRef}>
            <h1 className="print-header page-heading" style={{ height: "auto" }}>
              Scheduled Jobs
            </h1>
              <div style={{ width: "100%" ,paddingBottom: "5%" }}>
                <table
                  className="eventlist-table"
                  style={{ tableLayout: "fixed", width: "100%" }}
                >
                  <thead className="table-border">
                    <tr style={{ height: "auto", whiteSpace: "normal" }}>
                      <th style={{ width: "30%", textAlign: "left",background:"#04aa6d" }}>ID</th>
                      <th style={{ width: "20%", textAlign: "left",background:"#04aa6d" }}>Name</th>
                      <th style={{ width: "20%", textAlign: "left",background:"#04aa6d" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody className="table-border">
                  {loading ? (
                <tr>
                  <td align="center" colSpan={3}>
                    <span>Loading...</span>
                  </td>
                </tr>
              ) : (
                  (jobData?.data?.map((job, index) => (
                        <React.Fragment key={job.Id}>
                            <tr onClick={() => handleRowClick(index)}>
                                <td>{job.Id}</td>
                                <td>{job.Name}</td>
                                <td>
                                <span
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent row expansion when clicking "Run"
                        const confirmRun = window.confirm("Are you sure you want to run the "+job.Name+" job now?");
                        if (confirmRun) {
                            handleRun(job.Id); // Call the run function if confirmed
                        }
                    }}
                    style={{
                        fontWeight: 'bold', // Bold text
                        cursor: 'pointer', // Change cursor to pointer on hover
                        color: 'blue', // Change color to indicate it's clickable
                        textDecoration: 'underline', // Optional: underline for better indication
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = 'darkblue')} // Change color on hover
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'blue')} // Reset color on mouse leave
                >
                    Run
                                </span>
                                {job.Name === "Create Bulk Membership Order" && <span className="ms-5"
                                    onClick={(e) => {
                                        e.stopPropagation(); 
                                        sendReminderEmail();
                                    }}
                                    style={{
                                        fontWeight: 'bold', // Bold text
                                        cursor: 'pointer', // Change cursor to pointer on hover
                                        color: 'blue', // Change color to indicate it's clickable
                                        textDecoration: 'underline', // Optional: underline for better indication
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.color = 'darkblue')} // Change color on hover
                                    onMouseLeave={(e) => (e.currentTarget.style.color = 'blue')} // Reset color on mouse leave
                                >
                                    Reminder Email
                                </span>}
                                <ArrowIcon isExpanded={expandedRow === index} />
            
                                </td>
                            </tr>
                            {expandedRow === index && (
                                <tr>
                                    <td colSpan={3}>
                                        <table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>Instance ID</th>
                                                    <th>Started Date</th>
                                                    <th>Last Status</th>
                                                    <th>Last Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {job.Instances?.map((instance) => (
                                                    <tr key={instance.Instance_Id}>
                                                        <td>{instance.Instance_Id}</td>
                                                        <td>{instance.logs[0]?.status?dayjs(instance.logs[0].run_date).format("YYYY-MM-DD"):""}</td>
                                                        <td>{instance.logs[0]?.status?instance.logs[0].status:""}</td>
                                                        <td>{instance.logs[0]?.description?instance.logs[0].description:""}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))) ) }
                  </tbody>
                </table>
              </div>
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
      {showModal ? (
        (
          <div>
              {/* Your existing UI components */}
              
              <Modal show={showModal} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                      <Modal.Title>Select Fiscal Year</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                  <Form>
                  <Form.Check 
                      type="radio"
                      id="currentFiscalYear"
                      label="Current Fiscal Year"
                      name="fiscalYear"
                      checked={selectedFiscalYear === 'Current Fiscal Year'}
                      onChange={() => setSelectedFiscalYear('Current Fiscal Year')}
                  />
                  <Form.Check 
                      type="radio"
                      id="nextFiscalYear"
                      label="Next Fiscal Year"
                      name="fiscalYear"
                      checked={selectedFiscalYear === 'Next Fiscal Year'}
                      onChange={() => setSelectedFiscalYear('Next Fiscal Year')}
                  />
              </Form>
              <Form.Check 
                type="checkbox"
                id="emailInvoice"
                label="Email invoice to individuals"
                checked={emailInvoice}
                onChange={(e) => setEmailInvoice(e.target.checked)}
                className="mt-3"
                 />
                  </Modal.Body>
                  <Modal.Footer>
                      <Button type="submit" onClick={handleSubmit} disabled={!selectedFiscalYear} style={{ height: '40px' }}>
                          Submit
                      </Button>
                  </Modal.Footer>
              </Modal>
          </div>
      )
      ) : (
        <></>
      )}
    </>
  );
};
export default JobScreen;
